import { NgClass, NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { TrialStatus, UserAssignedTrialStatus } from '@app/+state/trials/trials.model';
import { CommonConstants } from '@core/common-constants';
import { BADGE_STATUS_COLORS, BadgeDirective, BadgePosition, BadgeSize } from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererParams } from 'ag-grid-community';
import { CustomDatePipe } from '../../shared/pipes/date/custom-date.pipe';

@Component({
  selector: 'app-ag-bundle-details',
  templateUrl: './ag-bundle-details.component.html',
  styleUrls: ['./ag-bundle-details.component.scss'],
  imports: [BadgeDirective, NgClass, NgStyle, CustomDatePipe],
})
export class AgBundleDetailsComponent {
  BADGE_STATUS_COLORS = BADGE_STATUS_COLORS;
  BadgePosition = BadgePosition;
  BadgeSize = BadgeSize;
  params: ICellRendererParams;
  highlightNewItems: boolean;
  isAllocated: boolean;
  toggle: boolean = false;
  greyOutText: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.highlightNewItems = this.params['highlightNewItems'] || false;
    this.isAllocated = this.params['isAllocated'] || false;
    const status = params.data?.status?.toLowerCase?.();
    this.greyOutText =
      status === UserAssignedTrialStatus.EXPIRED.toLowerCase() || status === TrialStatus.ENDED.toLowerCase();
  }

  refresh(): boolean {
    return false;
  }

  checkIsNew(): boolean {
    if (!this.highlightNewItems) {
      return false;
    }
    const currentDate = new Date();
    const data = this.params.data;
    const redeemedOn = new Date(data.redeemedOn);
    const daysSinceRedeemed = (currentDate.getTime() - redeemedOn.getTime()) / (3600 * 24 * 1000);
    return daysSinceRedeemed <= CommonConstants.entitlementNewPeriodInDays;
  }

  toggleDetails(): void {
    this.toggle = !this.toggle;
  }
}
